import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { AppConfig } from "@core_n/app.config";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { takeUntil } from 'rxjs/operators';
import { PresetWindowService } from '../preset-window.service';
import { SearchResult } from './../../asp/interfaces';
import { DndBusService } from './../dnd-bus.service';
import { VideoSplitService } from "./video-split.service";

interface videoSlot {
  data: SearchResult | null;
}

@Component({
  selector: "video-split",
  templateUrl: "./video-split.component.html",
  styleUrls: ["./video-split.component.scss"],
})
export class VideoSplitComponent implements OnInit {
  public viewSplits: any;
  public _VideoLayout: any;
  public fullscreenVideoId: number = null;
  private _unsubscribeAll$: Subject<any>;
  public isDragging = false;
  public currentPresetId = 0;

  public currentViewSplit: any = {
    id: 1,
    players: 1,
    value: "One",
  };

  constructor(
    private _cdr: ChangeDetectorRef,
    protected trans: TranslateService,
    private _dndBusService: DndBusService,
    public _videoSplitService: VideoSplitService
  ) {
    this._unsubscribeAll$ = new Subject();
  }

  ngOnInit(): void {
    this._videoSplitService.setLayout$.pipe(takeUntil(this._unsubscribeAll$)).subscribe(layoutId => this.setViewSplit(layoutId));
    this._dndBusService.dragStart$.pipe(takeUntil(this._unsubscribeAll$)).subscribe(() => this.isDragging = true);
    this.viewSplits = AppConfig.presets;
    this.viewSplitInit();
    this.subscribeToFullMapClicked();
    this._videoSplitService.currentPreset$.pipe(takeUntil(this._unsubscribeAll$)).subscribe(preset => 
      { 
        this.currentPresetId = preset?.id ?? 0;
      }
    );
  }

  viewSplitInit() {
    this.viewSplits = this.viewSplits.map((layout) => {
      if (layout.players < 7) return { ...layout, hide: () => false };
      else {
        return { ...layout, hide: () => true };
      }
    });
  }

  getSlotId(index: number){
    return `player${index}`;
  }

  showAddPreset(){
    this._videoSplitService.showAddPreset()
  }

  showUpdatePreset(){
    this._videoSplitService.showAddPreset()
  }

  clearSplitScreen() {
    this._videoSplitService.initSplitScreen()
  }

  isPlayerShown(index: number){
    return this.currentViewSplit.players >= (index + 1);
  }

  public onDropped(event: CdkDragDrop<SearchResult>,videoIndex: number){
    const newSensor = event.item.data.obj;
    this._videoSplitService.sensors = this._videoSplitService.sensors.map((s, i) => i == videoIndex ? newSensor : s);
    this._dndBusService.dragEnd();
    this.isDragging = false;
  }

  public setViewSplit(splitValue: number): void {
    if (splitValue != this.currentViewSplit.id) {
      this.currentViewSplit = this.viewSplits[splitValue - 1];
      this._videoSplitService.notifyChangeLayout(AppConfig.presets.find((e) => e.id == splitValue));
    }
    this._cdr.detectChanges();
  }

  public onViewSplitChange(splitValue: number): void {
    //now it will be the enum value
    if (splitValue) {
      this.setViewSplit(splitValue);
    }
  }

  get currentPresetText(): string {
    return "";
  }

  
  private subscribeToFullMapClicked() {
    this._videoSplitService.changeFullscreen$.pipe(takeUntil(this._unsubscribeAll$)).subscribe(() => this.clearSplitScreen())
  }

  ngOnDestroy() {
    this._unsubscribeAll$.next(null);
    this._unsubscribeAll$.complete();
  }
}
